export default __webpack_public_path__ + "static/media/bar_03.144e710a.svg";